<template>
  <div class="app-container">
    <div class="sec-list apply-box position-box" id="box-1">
      <div class="card">
        <div class="title">全面的输入模式</div>
        <div class="card-item-box flex">
          <div class="card-item" v-for="(item, index) in apImgList" :key="index">
            <img v-lazy="item.src" />
            <div class="desc white title bolder">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { apImgList } from './const.js'
export default {
  data() {
    return {
      apImgList
    }
  }
}
</script>
